export const slovakRegionsList = [
    'Bratislavský',
    'Trnavský',
    'Trenčiansky',
    'Nitriansky',
    'Žilinský',
    'Banskobystrický',
    'Prešovský',
    'Košický'
]
